module.exports = __webpack_public_path__ + "img/dicaChat.6e19bf58.png";